import { useServerSideFilters } from "@/hooks/useQueryFilters";
import { smbTransactionsTodosFilter } from "../utils/transactions-todos-filter";
import { useTransactionsLiveCountsSubscription } from "./live-counts";

export const useTransactionsTodosLiveCount = () => {
  const serverSideQuery = useServerSideFilters({
    query: smbTransactionsTodosFilter,
  });

  const { liveCounts, loading } = useTransactionsLiveCountsSubscription({
    query: serverSideQuery,
  });

  return { liveCounts, loading };
};
